import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-flex align-items-center" };
const _hoisted_4 = ["placeholder"];
const _hoisted_5 = ["title"];
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_7 = { class: "table-responsive" };
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_9 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
};
const _hoisted_10 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_11 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_12 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_13 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_14 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_15 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_16 = { key: 0 };
const _hoisted_17 = {
    colspan: "8",
    class: "text-center py-4"
};
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 text-capitalize" };
const _hoisted_19 = { class: "d-flex align-items-center text-capitalize" };
const _hoisted_20 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" };
const _hoisted_21 = ["onClick"];
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_27 = {
    key: 0,
    class: "badge text-outline-success"
};
const _hoisted_28 = {
    key: 1,
    class: "badge text-outline-danger"
};
const _hoisted_29 = { class: "form-check form-switch" };
const _hoisted_30 = ["checked", "onChange"];
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" };
const _hoisted_32 = { class: "dropdown" };
const _hoisted_33 = { class: "dropdown-menu" };
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["onClick"];
const _hoisted_36 = ["onClick"];
const _hoisted_37 = { key: 2 };
const _hoisted_38 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" };
const _hoisted_39 = { class: "mb-0 text-paragraph" };
const _hoisted_40 = { class: "mt-15 mt-md-0" };
const _hoisted_41 = { class: "pagination mb-0" };
const _hoisted_42 = ["onClick"];
const _hoisted_43 = {
    class: "modal fade",
    id: "confirmModal",
    tabindex: "-1",
    "aria-labelledby": "confirmModalLabel",
    "aria-hidden": "true"
};
const _hoisted_44 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_45 = { class: "modal-content" };
const _hoisted_46 = { class: "modal-header" };
const _hoisted_47 = {
    class: "modal-title",
    id: "confirmModalLabel"
};
const _hoisted_48 = { class: "modal-body text-center" };
const _hoisted_49 = { class: "mb-0" };
const _hoisted_50 = { class: "modal-footer" };
const _hoisted_51 = {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_EmptyTable = _resolveComponent("EmptyTable");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, null, -1)),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("form", {
                        class: "search-box position-relative me-15",
                        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["prevent"]))
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.searchQuery) = $event)),
                            type: "text",
                            class: "form-control shadow-none text-black rounded-0 border-0",
                            placeholder: _ctx.$t('lists.searchCustomer')
                        }, null, 8, _hoisted_4), [
                            [_vModelText, _ctx.searchQuery]
                        ]),
                        (_ctx.searchQuery)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleClear && _ctx.handleClear(...args))),
                                class: "bg-transparent text-muted transition p-0 border-0 position-absolute",
                                style: { "right": "40px", "top": "50%", "transform": "translateY(-50%)" },
                                title: _ctx.$t('lists.clearSearch')
                            }, [...(_cache[8] || (_cache[8] = [
                                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
                                ]))], 8, _hoisted_5))
                            : _createCommentVNode("", true),
                        _cache[9] || (_cache[9] = _createElementVNode("button", {
                            type: "submit",
                            class: "bg-transparent text-primary transition p-0 border-0"
                        }, [
                            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                        ], -1))
                    ], 32)
                ])
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('lists.id')), 1),
                                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('lists.fullName')), 1),
                                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('lists.email')), 1),
                                _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('lists.phone')), 1),
                                _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('lists.createdAt')), 1),
                                _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('lists.verification')), 1),
                                _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('lists.status')), 1),
                                _cache[11] || (_cache[11] = _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                                }, null, -1))
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                                    _createElementVNode("td", _hoisted_17, [
                                        _createVNode(_component_LoaderComponent)
                                    ])
                                ]))
                                : (!_ctx.isLoading && _ctx.allCustomers.length > 0)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.allCustomers, (customer, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: customer.id
                                        }, [
                                            _createElementVNode("th", _hoisted_18, [
                                                _createElementVNode("div", _hoisted_19, [
                                                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "form-check mb-0 text-capitalize" }, [
                                                        _createElementVNode("input", {
                                                            class: "form-check-input shadow-none",
                                                            type: "checkbox"
                                                        })
                                                    ], -1)),
                                                    _createElementVNode("div", _hoisted_20, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: ($event) => (_ctx.selectForDetail(customer))
                                                        }, _toDisplayString((_ctx.currentPage - 1) * _ctx.limit + index + 1) + " - " + _toDisplayString(_ctx.getShortUuid(customer.id)), 9, _hoisted_21)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_22, _toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1),
                                            _createElementVNode("td", _hoisted_23, _toDisplayString(customer.email), 1),
                                            _createElementVNode("td", _hoisted_24, _toDisplayString(customer?.phone_number ? (customer.phone_number.startsWith('+') ? customer.phone_number : '+' + customer.phone_number) : "-"), 1),
                                            _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.convertDateCreate(customer.created_at)), 1),
                                            _createElementVNode("td", _hoisted_26, [
                                                (customer.is_active)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('lists.verified')), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('lists.unverified')), 1))
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_29, [
                                                    _createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        checked: !!customer.is_active,
                                                        onChange: ($event) => (_ctx.toggleCustomerStatus(customer, $event.target.checked))
                                                    }, null, 40, _hoisted_30)
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_31, [
                                                _createElementVNode("div", _hoisted_32, [
                                                    _cache[16] || (_cache[16] = _createElementVNode("button", {
                                                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                        type: "button",
                                                        "data-bs-toggle": "dropdown",
                                                        "aria-expanded": "false"
                                                    }, [
                                                        _createElementVNode("i", { class: "flaticon-dots" })
                                                    ], -1)),
                                                    _createElementVNode("ul", _hoisted_33, [
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.goToView(customer))
                                                            }, [
                                                                _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('lists.view')), 1)
                                                            ], 8, _hoisted_34)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.goToEdit(customer))
                                                            }, [
                                                                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('lists.edit')), 1)
                                                            ], 8, _hoisted_35)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center shadow-none",
                                                                "data-bs-toggle": "modal",
                                                                "data-bs-target": "#confirmModal",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectionCustomer(customer))
                                                            }, [
                                                                _cache[15] || (_cache[15] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('lists.delete')), 1)
                                                            ], 8, _hoisted_36)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]));
                                    }), 128))
                                    : (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                                        _createVNode(_component_EmptyTable, {
                                            message: _ctx.$t('lists.noCustomers'),
                                            colspan: 10,
                                            textClass: "text-muted"
                                        }, null, 8, ["message"])
                                    ]))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.paginationInfo), 1),
                    _createElementVNode("nav", _hoisted_40, [
                        _createElementVNode("ul", _hoisted_41, [
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "First",
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.changePage(1)), ["prevent"]))
                                }, [...(_cache[17] || (_cache[17] = [
                                        _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1),
                                        _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                    ]))])
                            ], 2),
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.getStartPage() === 1 }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Previous Group",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.changePage(_ctx.getStartPage() - 1)), ["prevent"]))
                                }, [...(_cache[18] || (_cache[18] = [
                                        _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                    ]))])
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generatePageNumbers(), (page) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: page,
                                    class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                                }, [
                                    _createElementVNode("a", {
                                        class: "page-link",
                                        href: "#",
                                        onClick: _withModifiers(($event) => (_ctx.changePage(page)), ["prevent"])
                                    }, _toDisplayString(page), 9, _hoisted_42)
                                ], 2));
                            }), 128)),
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.getEndPage() >= _ctx.totalPages }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Next Group",
                                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.changePage(_ctx.getEndPage() + 1)), ["prevent"]))
                                }, [...(_cache[19] || (_cache[19] = [
                                        _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                    ]))])
                            ], 2),
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Last",
                                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event) => (_ctx.changePage(_ctx.totalPages)), ["prevent"]))
                                }, [...(_cache[20] || (_cache[20] = [
                                        _createElementVNode("i", { class: "flaticon-chevron" }, null, -1),
                                        _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                    ]))])
                            ], 2)
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("h5", _hoisted_47, _toDisplayString(_ctx.$t('lists.confirmDeleteUser')), 1),
                        _cache[21] || (_cache[21] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                        _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-exclamation-triangle warning-icon" }, null, -1)),
                        _createElementVNode("p", _hoisted_49, [
                            _createTextVNode(_toDisplayString(_ctx.$t('lists.confirmDeleteUserText')), 1),
                            _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('lists.confirmDeleteUserAction')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("button", _hoisted_51, [
                            _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('lists.cancel')), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger",
                            onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.deleteCustomerAction(_ctx.customerSelected))),
                            "data-bs-dismiss": "modal"
                        }, [
                            _cache[25] || (_cache[25] = _createElementVNode("i", { class: "fas fa-trash-alt me-2" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('lists.delete')), 1)
                        ])
                    ])
                ])
            ])
        ])
    ], 64));
}
